module.exports = new __parcel__URL__("lexus-car.5f267fd4.png").toString();